<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenz · Qualität &amp; Sicherheit</p>

      <h2 class="presentation-page__title">Kernkompetenz Qualität &amp; Sicherheit</h2>

      <p class="presentation-page__text">
        Lückenlos dokumentiert. Banken- und versicherungstauglich. Kein Detail bleibt unbelegt.
      </p>

      <div class="presentation-page__body presentation-page__body--split">
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="item in listItems" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--stats">
          <div class="presentation-page__stat-grid">
            <div
              v-for="(row, rowIndex) in statRows"
              :key="rowIndex"
              class="presentation-page__stat-grid-row"
            >
              <article
                v-for="stat in row"
                :key="stat.label"
                :class="[
                  'presentation-page__stat-card',
                  'presentation-page__stat-card--compact',
                  `presentation-page__stat-card--${stat.accent}`,
                ]"
              >
                <p class="presentation-page__stat-value">{{ stat.value }}</p>
                <p class="presentation-page__stat-label">{{ stat.label }}</p>
                <p class="presentation-page__stat-detail">{{ stat.detail }}</p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage19',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  computed: {
    statRows() {
      return [this.stats.slice(0, 2), this.stats.slice(2, 4)];
    },
  },

  data() {
    return {
      listItems: [
        'Kontinuierliche Trainings- und Schulungsmaßnahmen',
        'Standardisierte Prüfprozesse nach dem 4-Augen-Prinzip',
        'Sicherheitsausrüstung für jedes Teammitglied',
        'Lückenlose digitale Dokumentation',
        'Live-Abnahmen bei jedem Arbeitsschritt',
      ],
      stats: [
        {
          accent: 'brand-primary',
          value: '4',
          label: 'Augen-Prinzip',
          detail: 'Bei jeder Abnahme',
        },
        {
          accent: 'brand-teal',
          value: '100%',
          label: 'Foto-Protokoll',
          detail: 'Jeder Arbeitsschritt',
        },
        {
          accent: 'brand-primary',
          value: 'DIN',
          label: 'VDE · RAL',
          detail: 'Normgerecht geprüft',
        },
        {
          accent: 'brand-teal',
          value: '0',
          label: 'Open Defects',
          detail: 'Bei Übergabe',
        },
      ],
    };
  },
};
</script>
